import { useRef } from 'react';
import { useApolloClient, ApolloLink, from } from '@apollo/client';
import isPortalSpecificObjectType from 'customer-data-objects/crmObject/isPortalSpecificObjectType';
import { Metrics } from 'crm-object-board-core/performance';
import { useDataFetchingClient } from 'data-fetching-client';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const TrackQueryProvider = ({
  children,
  queries,
  objectTypeId
}) => {
  const client = useApolloClient();
  const dfcClient = useDataFetchingClient();
  const dfcLink = useRef(null);
  const apLink = useRef(null);
  //only do this once
  if (dfcLink.current && apLink.current) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  const roundTripLink = new ApolloLink((operation, forward) => {
    // Called before operation is sent to server
    operation.setContext({
      start: performance.now()
    });
    return forward(operation).map(data => {
      // Called after server responds
      const duration = performance.now() - operation.getContext().start;
      const found = queries.find(q => q === operation.operationName);
      if (found) {
        const metricObjectTypeId = isPortalSpecificObjectType(objectTypeId) ? 'custom' : objectTypeId;
        Metrics.timer(found, {
          metricObjectTypeId
        }).update(duration);
      }
      return data;
    });
  });
  apLink.current = from([roundTripLink, client.link]);
  client.setLink(apLink.current);
  dfcLink.current = from([roundTripLink, dfcClient.link]);
  dfcClient.setLink(dfcLink.current);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};